// Recidiviz - a data platform for criminal justice reform
// Copyright (C) 2026 Recidiviz, Inc.
//
// This program is free software: you can redistribute it and/or modify
// it under the terms of the GNU General Public License as published by
// the Free Software Foundation, either version 3 of the License, or
// (at your option) any later version.
//
// This program is distributed in the hope that it will be useful,
// but WITHOUT ANY WARRANTY; without even the implied warranty of
// MERCHANTABILITY or FITNESS FOR A PARTICULAR PURPOSE.  See the
// GNU General Public License for more details.
//
// You should have received a copy of the GNU General Public License
// along with this program.  If not, see <https://www.gnu.org/licenses/>.
// =============================================================================

import { useTypedParams } from "react-router-typesafe-routes/dom";

import { State } from "~@jii/paths";
import { useUsMaTranslations } from "~@jii/translation";

import { useReentryAnalytics } from "../../../../hooks/useReentryAnalytics";
import { GUIDE_TOPICS } from "../../ctaConfigs";
import { ReentryVideoLearnMoreRow } from "../ReentryVideo/ReentryVideoLearnMoreRow/ReentryVideoLearnMoreRow";
import {
  CardsRow,
  SectionLabel,
  TopicCard,
  TopicIcon,
  TopicLabel,
} from "./GuideCta.styles";

export type GuideCtaProps = {
  onOpenVideo: () => void;
};

export const GuideCta = ({ onOpenVideo }: GuideCtaProps) => {
  const { t } = useUsMaTranslations();
  const routeParams = useTypedParams(State.Resident);
  const trackEvent = useReentryAnalytics();

  return (
    <div>
      <SectionLabel>
        {t(($) => $.reentry.overview.guideCta.sectionLabel)}
      </SectionLabel>

      <ReentryVideoLearnMoreRow onOpenVideo={onOpenVideo} />

      <CardsRow>
        {GUIDE_TOPICS.map(({ slug, iconSrc, label }) => (
          <TopicCard
            key={slug}
            to={State.Resident.UsMaReentry.Guide.buildPath({
              ...routeParams,
              topicSlug: slug,
            })}
            onClick={() =>
              trackEvent("frontend_reentry_home_cta_clicked", {
                cta: "topic_page",
                topicId: slug,
              })
            }
          >
            <TopicIcon src={iconSrc} alt="" />
            <TopicLabel>{label(t)}</TopicLabel>
          </TopicCard>
        ))}
      </CardsRow>
    </div>
  );
};
